module.exports = __webpack_public_path__ + "static/media/ICONO-CONTACT.9128d54e.png";